import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/common/Button';
import { Loader2 } from 'lucide-react';

interface PaymentMethodSelectionProps {
  amount: number;
  onPaymentMethodSelected: (method: 'paypal' | 'pos') => void;
  isLoading?: boolean;
}

const PaymentMethodSelection = ({ amount, onPaymentMethodSelected, isLoading = false }: PaymentMethodSelectionProps) => {
  const { t } = useTranslation();
  const [selectedMethod, setSelectedMethod] = useState<'paypal' | 'pos' | null>(null);

  const handleMethodSelect = (method: 'paypal' | 'pos') => {
    console.log("handleMethodSelect: " + method);
    setSelectedMethod(method);
    onPaymentMethodSelected(method);
  };

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-foreground text-sm">{t('preparingPayment')}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-xl font-bold text-foreground mb-2">
          {t('selectPaymentMethod')}
        </h2>
        <p className="text-foreground mb-4">
          {t('amountToPay')} {amount.toFixed(2)} KM
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <Button
          onClick={() => handleMethodSelect('paypal')}
          variant={selectedMethod === 'paypal' ? 'default' : 'outline'}
          className="h-16 relative"
        >
          <div className="flex flex-col items-center justify-center w-full">
            <span className="font-semibold">{t('payWithPayPal')}</span>
            <span className="text-sm opacity-75">{t('payOnline')}</span>
          </div>
        </Button>

        <Button
          onClick={() => handleMethodSelect('pos')}
          variant={selectedMethod === 'pos' ? 'default' : 'outline'}
          className="h-16 relative"
        >
          <div className="flex flex-col items-center justify-center w-full">
            <span className="font-semibold">{t('payWithPOS')}</span>
            <span className="text-sm opacity-75">{t('payInPerson')}</span>
          </div>
        </Button>
      </div>
    </div>
  );
};

export default PaymentMethodSelection;